// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","joinButton":"Modal_joinButton__XXNrn","open":"Modal_open__iRQcY"};